import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { CircleRounded, ChangeHistoryRounded, SquareRounded } from "@mui/icons-material";

/**
 * ReadinessStatusChip — AIC-001-BLD-WEB Phase 3.
 * Status is NEVER color alone (accessibility + shop-floor sunlight): color + icon + word.
 *   GREEN ●  / AMBER ▲  / RED ■
 */
const MAP = {
  GREEN: { color: "#2E7D32", label: "GREEN", Icon: CircleRounded },
  AMBER: { color: "#ED6C02", label: "AMBER", Icon: ChangeHistoryRounded },
  RED: { color: "#C62828", label: "RED", Icon: SquareRounded },
};

export default function ReadinessStatusChip({ status, size = "small" }) {
  const s = MAP[status] || MAP.RED;
  const px = size === "large" ? 20 : 14;
  const { Icon } = s;
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
      <Icon sx={{ fontSize: px, color: s.color }} aria-hidden />
      <Typography component="span" variant={size === "large" ? "subtitle2" : "caption"}
        sx={{ fontWeight: 700, color: s.color, letterSpacing: 0.4 }}>
        {s.label}
      </Typography>
    </Box>
  );
}

ReadinessStatusChip.propTypes = {
  status: PropTypes.oneOf(["GREEN", "AMBER", "RED"]).isRequired,
  size: PropTypes.oneOf(["small", "large"]),
};
